// ----------------------------------------------
// useNavigationHandlers.js
// ----------------------------------------------
// This custom React hook simplifies navigation within a React Router-enabled app.
// It provides reusable functions to go back or navigate to a new route programmatically.

import { useNavigate } from "react-router-dom"; // React Router hook for programmatic navigation

// Define and export the custom hook
export const useNavigationHandlers = () => {
  const navigate = useNavigate(); // Initialize navigation function from React Router

  // Navigate to the previous page in browser history
  const handleGoBack = () => {
    navigate(-1); // Equivalent to window.history.back()
  };

  // Navigate to a specific path
  const handleNext = (path) => {
    navigate(path); // Push a new entry onto the history stack
  };

  // Return the handlers to be used in components
  return {
    handleGoBack,
    handleNext,
  };
};
